<template>
  <div class="container-fluid" :style="{ paddingTop: this.$parent.$data.navbarHeight + 'px' }">
    <ProductItem v-if="Product" :productCategory="productCategory" :Product="Product"/>
    <div class="row productList">
      <div class="col">
        <div v-for="productCategory in productsData" :key="productCategory.id">
          <div class="productCategoryName" :id="'productCategory_' + productCategory.id" :ref="'productCategory_' + productCategory.id">{{productCategory.Name}}</div>
          <div v-for="Product in productCategory.Products" :key="Product.id" @click.stop="openProductItemModal(productCategory, Product)">
            <div class="Card card" :class="{'noSalesStatus': Product.salesStatus == 0}">
              <div class="productData">
                <div class="imageField" @click.stop="showProductModal(Product)">
                  <div class="Image" v-if="Product.Image"><img :src="Domain + Product.Image" loading="lazy"></div>
                  <div class="Fas" v-else><i class="fas fa-utensils fa-3x"></i></div>
                </div>
                <div class="nameField">
                  <div class="productName">{{Product.Name}}</div>
                  <span class="productPrice">NT${{Product.Price}}</span>
                </div>
              </div>
              <div class="productBuy" v-if="Product.productLabels.length == 0 && Product.salesStatus == 1">
                <button type="button" class="btn btn-sm" @click.stop="editProductCount(productCategory, Product, -1)">
                  <i class="fas fa-minus"></i>
                </button>
                <span class="Count" v-bind:id="Product.id">{{Product.Count}}</span>
                <button type="button" class="btn btn-sm" @click.stop="editProductCount(productCategory, Product, 1)">
                  <i class="fas fa-plus"></i>
                </button>
              </div>
              <div class="productItems" v-if="Product.productLabels.length > 0 && Product.salesStatus == 1">
                <div class="addSign">. . .</div>
              </div>
              <div class="noProduct" v-if="Product.salesStatus == 0">售完</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Global } from '@/Service/GlobalService'
import ProductItem from '@/components/Shop/ProductItem'
export default {
  name: "Products",
  components: { ProductItem },
  data() {
    return {
      Domain: Global.Domain, // 網域位置
      productCategory: null, // 使用者選中的商品的類別
      Product: null, // 使用者選中的商品
    }
  },
  props: {
    productsData: Object
  },
  methods: {
    /* 開啟商品視窗 */
    showProductModal: function(Product) {
      this.$parent.$data.productName = Product.Name
      this.$parent.$data.productPrice = Product.Price
      this.$parent.$data.productContent = Product.Content
      this.$parent.$data.productImage = Product.Image
      this.$parent.$data.hasProduct = Product.salesStatus
      $("#ProductModal").modal('show')
    },
    /* 開啟商品細項視窗 */
    openProductItemModal: async function(productCategory, Product) {
      this.$data.productCategory = productCategory
      this.Product = { ...Product }
      if (this.Product.productLabels.length == 0) return
      $("#productItemModal").modal('show')
    },
    /* 變更商品數量 */
    editProductCount(productCategory, Product, Count) {
      const productsData = this.$parent.$data.productsData
      const cart = this.$parent.$data.Cart[0].Data

      const category = productsData.find(c => c.id === productCategory.id)
      if (!category) return

      const product = category.Products.find(p => p.id === Product.id)
      if (!product) return

      if (typeof product.Count !== 'number') product.Count = 0

      product.Count += Count

      if (product.Count < 0) product.Count = 0

      const cartIndex = cart.findIndex(o => o.productId === product.id)

      if (product.Count > 0) {
        if (cartIndex !== -1) {
          cart[cartIndex].Count = product.Count
        } else {
          cart.push({
            productCategoryId: category.id,
            productId: product.id,
            Name: product.Name,
            Price: product.Price,
            Image: product.Image,
            Count: product.Count
          })
        }
      } else {
        if (cartIndex !== -1) cart.splice(cartIndex, 1)
      }

      localStorage.setItem('Cart.' + Global.Shop.id, JSON.stringify(cart))
    }
  }
}
</script>

<style lang="scss" scoped>
.row {
  margin: 0px;
}
.productList {
  margin-bottom: 75px;
  .productCategoryName {
    margin: 10px 0px;
    margin-left: 15px;
    font-size: 18px;
    font-weight: 900;
    color: #87CEFAAA;
    text-shadow: 1px 1px 0 #000000;
  }
  .Card {
    margin: 0px 10px;
    display: inline-block;
    width: calc(100% - 20px);
    position: relative;
    border: 1px solid rgba(0,0,0,.125);
    border-radius: 0.25rem;
    .productData {
      .imageField {
        float: left;
        margin: 10px;
        > .Fas {
          background-color: #5599FF;
          width: 80px;
          height: 80px;
          line-height: 80px;
          border-radius: 8px;
          text-align: center;
          color: #FFFFFF;
          svg {
            vertical-align: middle;
          }
        }
        > .Image {
          height: 80px;
          width: 80px;
          text-align: center;
          position: relative;
          overflow: hidden;
          > img {
            border-radius: 8px;
            max-height: 80px;
            max-width: 80px;
            width: auto;
            height: auto;
            position: absolute;  
            top: 0;  
            bottom: 0;  
            left: 0;  
            right: 0;  
            margin: auto;
          }
        }
      }
      .nameField {
        float: left;
        .productName {
          max-width: 30vw;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-weight: bold;
        }
        .productPrice {
          display: inline-block;
          color: #FFBB00;
          font-weight: bold;
        }
      }
      .nameField:before {
        content: '';
        height: 100%;
        display: inline-block;
        vertical-align: middle;
      }
    }
    .productBuy {
      float: right;
      padding-right: 20px;
      line-height: 100px;
      > button {
        border-radius: 16px;
        background-color: #5599FF;
        color: #FFFFFF;
      }
      > button:first-child {
        margin-right: 15px;
      }
      .Count {
        font-family:'微軟正黑體';
        font-weight: bold;
        font-size: 20px;
        margin-right: 15px;
      }
    }
    .productItems {
      position: absolute;
      right: 0;
      bottom: 0;
      color: #5599FF;
      font-size: 18px;
      .addSign {
        margin-right: 10px;
        font-size: 28px;
        font-weight: bold;
      }
    }
  }
  .noSalesStatus {
    background-color: rgb(173, 173, 173);
    color: #FFFFFF;
    .Fas {
      background-color: rgb(147, 146, 146) !important;
    }
    .noProduct {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 20px;
      font-weight: bold;
    }
    img {
      // border: #FFFFFF99 1px solid;
      // filter: grayscale(60%);
    }
    .productPrice {
      color: #FFFFFF !important;
    }
  }
}
@media(max-width: 540px) {
  .productList {
    .noSalesStatus {
      .noProduct {
        top: 50%;
        left: 70%;
        transform: translate(-70%, -50%);
      }
    }
  }
}
</style>